// @core/api/endpoints/chat/mark_as_read.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  MarkAsReadRequest,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Mark messages as read
 * Updates the read position for the current user in the conversation, resetting the unread counter. Can optionally mark only up to a specific message.
 */
export async function MarkAsRead(
  conversation_id: string,
  data: MarkAsReadRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/read`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
